import { useState } from 'react';

import PrimaryButton from 'components/form/buttons/primaryButton';
import ModalApp from 'components/modalApp';
import CafeteriaCreateForm from './lib/form';

import * as S from './styles';
import { useActions } from 'common/hooks/useActions';

/*
 * `SecundButton hasIcon` drew the design's own plus as a solid blue glyph
 * inside a teal button — the icon came from `/icons/plus.svg` with its own
 * fill. It is an inline stroke icon now, so it inherits the button's ink.
 */
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function CafeteriaMenuManagementCreate() {
  const [show, setShow] = useState<boolean>(false);

  const { floorsRequestAction } = useActions();

  const fetchData = () => {
    floorsRequestAction({ page: 1, page_size: 10 });
  };

  const handleShowModal = () => {
    setShow(true);
  };

  const handleCloseModal = () => {
    setShow(false);
  };

  return (
    <S.Content>
      <PrimaryButton onClick={handleShowModal}>
        <PlusIcon />
        New floor
      </PrimaryButton>

      <ModalApp show={show} fixed handleClose={handleCloseModal} title="New floor" style={{ maxWidth: 400 }}>
        <CafeteriaCreateForm closeModal={handleCloseModal} fetchData={fetchData} key={String(show)} />
      </ModalApp>
    </S.Content>
  );
}
